import uiRouter from 'angular-ui-router';
import socialSecurityComponent from './socialSecurity.component';
import { ROUTES } from 'common/domain/routes';
import { STATES } from 'common/domain/states';

import headerSS from './headerSS/headerSS';
import socialSecurityList from './socialSecurityList/socialSecurityList';

let socialSecurityModule = angular.module('social-security.socialSecurity', [
  uiRouter, headerSS, socialSecurityList
])

  .config(($stateProvider) => {
    'ngInject';

    $stateProvider
      .state(STATES.SOCIAL_SECURITY, {
        parent: STATES.MAIN_ROUTING,
        url: ROUTES.SOCIAL_SECURITY,
        component: 'socialSecurity',
        data: {
          requiresAuth: true,
        },
      });
  })

  .component('socialSecurity', socialSecurityComponent)

  .name;

export default socialSecurityModule;



// WEBPACK FOOTER //
// ./client/app/social-security.module/features/socialSecurity/socialSecurity.js